module.exports = __webpack_public_path__ + "740aa37fc1dfd4f1e73800ff08bbb347.MP3";